import { render, staticRenderFns } from "./EBook.vue?vue&type=template&id=56396d0f&scoped=true&"
import script from "./EBook.vue?vue&type=script&lang=js&"
export * from "./EBook.vue?vue&type=script&lang=js&"
import style0 from "./EBook.vue?vue&type=style&index=0&id=56396d0f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56396d0f",
  null
  
)

export default component.exports